// src/components/Icon.tsx
import React from "react";

// import all svg files as a record: path -> url
const icons = import.meta.glob("../assets/icons/*", {
  eager: true,
  import: "default",
}) as Record<string, string>;

interface IconProps {
  name: string; // e.g. "home", "user", "settings"
  alt?: string;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ name, alt, className }) => {
  const path = `../assets/icons/${name}`;
  const src = icons[path];

  if (!src) {
    console.warn(`Icon not found: ${name}`);
    return null;
  }

  return <img src={src} alt={alt || name} className={className} />;
};
